import {lazy} from 'react';

const SendCampaignInvitation = lazy(() => import('./SendCampaignInvitation'));

export default SendCampaignInvitation;
